import React from 'react';
const Alert = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2801_17)">
        <path
          d="M8 5.35176L8 8.00004M8 10.6483C8 10.6483 7.99596 10.6483 7.99338 10.6483M1.37931 8.00004C1.37931 4.34353 4.34349 1.37935 8 1.37935C11.6565 1.37935 14.6207 4.34353 14.6207 8.00004C14.6207 11.6565 11.6565 14.6207 8 14.6207C4.34349 14.6207 1.37931 11.6565 1.37931 8.00004Z"
          stroke="#DC2626"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2801_17">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Alert;